import { ProductPage } from "./ProductPage";
import { buildTv5Config } from "./configs/tv5";

export function Tv5Page() {
  return <ProductPage build={buildTv5Config} />;
}
